export default {
  email: [
    {
      method: "string"
    },
    {
      method: "email",
      options: "Invalid email address"
    },
    {
      method: "required",
      options: "Email is required"
    }
  ]
};
